import React from "react";
import "./CheckboxInput.css";

const CheckboxInput = ({
  isChecked,
  textValue,
  section,
  question,
  answer,
  handleFunction,
  concealedRadio,
  handleOther,
  isInError,
}) => {
  return (
    <div
      className={
        "questionare_checkbox_field_container " +
        (isChecked ? " questionare_checkbox_field_container-selected " : "") +
        (concealedRadio ? " quest_checkbox_clickable " : "") +
        (isInError ? " container_error" : "")
      }
      onClick={() => (concealedRadio ? handleFunction(section, question, answer) : "")}
    >
      {concealedRadio ? (
        <div className="questionareField_radio_container">
          <div className={"questionareField_radio_box " + (isChecked ? "radio_checked" : "")}>
            <div className={"questionareField_radio_box_inner " + (isChecked ? "container_checked" : "")}></div>
          </div>
        </div>
      ) : (
        <div
          className={"questionare_checkbox " + (isChecked ? "questionare_checkbox_selected" : "")}
          onClick={() => handleFunction(section, question, answer)}
        ></div>
      )}

      <div className={concealedRadio ? "questionareField_question" : "questionareField_question_checkbox"}>
        {textValue}
      </div>
      {textValue === "Other" && isChecked && (
        <input
          type="text"
          className="questionareField_additional_inp"
          onChange={(e) => handleOther(section, question, e.target.value)}
        />
      )}
    </div>
  );
};

export default CheckboxInput;
